/** @format */

// This file can be replaced during build by using the `fileReplacements` array in the project.json file

import { IEnvironment } from '@shared/data-access/interfaces';
import { LoggerLevel } from '@shared/data-access/services';
import { devEnvironmentDefaults } from '@shared/data-access/config';

const redirectingServiceBase = '/myaccount/services/redirectingservice';

export const environment: IEnvironment = {
	api: {
		spring: {
			microService: {
				...devEnvironmentDefaults.api.spring.microService,
				logger: {
					AZ: 'https://active-checkout-logger-ecs.iso.an01.pcf.dcsg.com/'
				},
				product: {
					GCP: 'https://active-productservice.iso.gn01.pcf.dcsg.com/',
					AZ: 'https://active-productservice.iso.an01.pcf.dcsg.com/',
					VS: 'https://active-productservice.iso.vn01.pcf.dcsg.com/'
				}
			},
			microServiceProxy: {
				...devEnvironmentDefaults.api.spring.microServiceProxy,
				breadcrumb: {
					path: `/p/spring/msvc/breadcrumb/`,
					timeout: '15000'
				},
				category: {
					path: `/p/spring/msvc/category/`,
					timeout: '15000'
				},
				killswitch: {
					path: `/p/wcs/msvc/killswitch/`,
					timeout: '15000'
				},
				logger: {
					path: `/cart/spring/msvc/logger/`,
					timeout: '15000'
				},
				product: {
					path: `/p/spring/msvc/product/`,
					timeout: '15000'
				},
				promoservice: {
					path: `/p/esb/msvc/promo/`,
					timeout: '15000'
				},
				seoservice: {
					path: `/p/spring/msvc/seo/`,
					timeout: '15000'
				}
			}
		},
		nestjs: {
			microService: {
				product: {
					GCP: 'https://active-productservice-nest.iso.gn01.pcf.dcsg.com/',
					AZ: 'https://active-productservice-nest.iso.an01.pcf.dcsg.com/',
					VS: 'https://active-productservice-nest.iso.vn01.pcf.dcsg.com/'
				}
			},
			microServiceProxy: {
				product: {
					path: `/p/nest/msvc/product/`,
					timeout: '15000'
				}
			}
		},
		dataScience: {
			basePath: '/api/spring/msvc/ds/v1/',
			target: 'https://staging-ds-recs-details.iso.an01.pcf.dcsg.com'
		},
		athleteEngine: {
			AZ: 'https://main-athlete-engine-staging.iso.an01.pcf.dcsg.com'
		},
		loyaltyPointsCalculationService: {
			partnerKey: 'botf',
			secretKey: 'ASfCzTQyKvuuV8ocnzPP'
		},
		passwordRequirements: {
			basePath: '/api/v1/passwords',
			proxy: {
				server: 'http://localhost:8010'
			}
		},
		cart: {
			basePath: '/api/v1/carts',
			proxy: {
				server: 'http://localhost:8070'
			},
			version: '4'
		},
		saveForLaterCart: {
			basePath: '/api/v1/saved-carts',
			proxy: {
				server: 'http://localhost:8060'
			}
		},
		checkout: {
			basePath: '/api/v1/checkouts',
			basePathV2: '/api/v2/checkouts',
			proxy: {
				server: 'http://localhost:8080'
			}
		},
		criteo: {
			baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
			nolog: 1,
			partnerId: {
				dsg: 25953,
				gg: 35855
			}
		},
		myaccount: {
			basePath: '/myaccount/services/',
			partnerKey: 'cart_ui',
			secretKey: 'BHOuAV90ho1uUSULXWEl'
		},
		myLocker: {
			basePath: '/v1/mylocker'
		},
		identityService: {
			basePath: '/athleterecord/services/redirectingservice/identityservice',
			partnerKey: 'cart_ui',
			secretKey: 'BHOuAV90ho1uUSULXWEl'
		},
		athleteManagementService: {
			basePath: '/myaccount/services/redirectingservice/athletemanagementservice',
			partnerKey: 'cart_ui',
			secretKey: 'BHOuAV90ho1uUSULXWEl'
		},
		gtgt: {
			basePath: '/api/v1/gtgt-evaluator',
			proxy: {
				server: 'http://localhost:8072'
			}
		},
		elastic: {
			inventory: 'https://availability.dksxchange.com',
			availability: 'https://availability.dksxchange.com',
			autoSuggestUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/',
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/'
		},
		node: {
			microService: {
				productimages: {
					GCP: 'https://product-images.iso.gn01.pcf.dcsg.com/',
					AZ: 'https://product-images.iso.an01.pcf.dcsg.com/',
					VS: 'https://product-images.iso.vn01.pcf.dcsg.com/'
				}
			},
			microServiceProxy: {
				productimages: {
					path: `/p/node/msvc/mediaset/`,
					timeout: '15000'
				}
			}
		},
		esb: {
			gatewayUrl: 'https://gateway.dksxchange.com/',
			gatewayUrlProxy: {
				path: `/p/esb/api/`,
				timeout: '15000'
			}
		},
		homr: {
			previewLinks: true,
			proxy: {
				path: `/dcsg-ngx-home/homr/v2/api/`,
				timeout: '15000'
			},
			url: 'https://dev-home-dsg-dcsg-ngx.iso.an01.pcf.dcsg.com/dcsg-ngx-home/homr/v2/api',
			scene7Url: '//dks.scene7.com/is/image/dksfed/',
			scene7UrlCDN: '//dks.scene7.com/is/image/dkscdn/'
		},
		aemFoundationDetails: {
			// to be updated as part of https://dcsgcloud.atlassian.net/browse/SPPJ-87
			proxy: {
				path: `/graphql/execute.json/ContentFragments/getFoundationDetailsList`,
				timeout: '15000'
			},
			url: 'https://publish-p42408-e166538.adobeaemcloud.com'
		},
		wscBaseUrl: 'https://meta.dickssportinggoods.com/',
		brandify: {
			brandifyBaseUrl: 'https://hosted.where2getit.com/',
			proxy: {
				path: `/p/store/locator/`
			}
		},
		paypal: 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=',
		tickerUrl: 'https://fdhmfhecfi.execute-api.us-east-1.amazonaws.com/prod/',
		ceops: devEnvironmentDefaults.api.ceops,
		reactMarginals: devEnvironmentDefaults.api.reactMarginals,
		avsApi: {
			origin: 'https://avs.dickssportinggoods.com',
			baseUrl: '/avs/verifyAddress',
			healthCheckUrl: '/avs/health',
			PerfTestingUrl: 'https://dsg-avs-engine-stage.iso.vn01.pcf.dcsg.com',
			proxyPath: '/checkout'
		},
		avsApiV2: {
			origin: 'https://dsg-avs-engine.dcsg.com',
			baseUrl: '/v2/address/verification',
			PerfTestingUrl: 'https://dsg-avs-engine-stage.iso.vn01.pcf.dcsg.com',
			proxyPath: '/checkout'
		},
		stores: {
			origin: 'https://availability.dickssportinggoods.com/api/v1/stores'
		},
		exComm: {
			origin: '/v1/preference',
			marketing: '/v2/TextSubscription'
		},
		smsOptIn: {
			basePath: '/ec/v1/sms/subscription'
		}
	},
	apiTokens: {
		smsOptIn: {
			apimSecret: '85a82729322c405093a4d6997eb60bf1'
		},
		brandify: {
			storeLocator: {
				calia: '66C2D0CC-3E0F-11EA-9E1B-6066C403F339',
				dsg: '8D669860-73FB-11E8-8752-FF2F0D70A832',
				gg: 'CE23B360-C828-11E4-B146-ED9AA38844B8',
				// TODO cart vrst
				vrst: '',
				// pl: '',
				g3: ''
			}
		},
		esb: {
			api: '33ec2350-f058-11e5-9ee0-83dbbe9e44cb',
			api2: 'b9d21970-5d8f-11e7-9f8a-e75a897e3fb7',
			data: 'a529cf50-e477-11e5-9ee0-b6503a8b49a4',
			identity: '05acf220-cac0-11e5-aeb0-8b572127b1fd',
			myaccount: '3665c150-fa89-11e5-afd3-98f6a0e878e7',
			inventory: '1e370cd0-90fd-11e8-88c8-b1d2f2dd8b93'
		},
		contentAPI: {
			key: 'VDJSNWMzTmxlVUpsZEdFPSA5U1QmWTI8PWF8R0IoOWtBLEdVYzsmY1JMelBYI2k='
		},
		elastic: {
			availability: 'botf-17b06f58-159a-11ec-ae0d-93a5657ddf9'
		},
		exComm: {
			partnerKey: 'Checkout2',
			secretKey: 'rXUvsEVtNlmAvrVCCZku',
			marketing: {
				secretKey: 'KG0OOIqW20GQXTOyAhsf',
				partnerKey: 'Checkout'
			}
		},
		party: {
			partnerKey: 'botf',
			// secretKey: 'ASfCzTQyKvuuV8ocnzPP'
			secretKey: 'KqIj3Fofw0255D06Q5bl'
		},
		radar: {
			dsg: { publishableKey: 'prj_test_pk_00f6600081c41843baa7435fb9185ed5ee26e4b6' },
			gg: { publishableKey: 'prj_test_pk_00f6600081c41843baa7435fb9185ed5ee26e4b6' },
			g3: { publishableKey: 'prj_test_pk_00f6600081c41843baa7435fb9185ed5ee26e4b6' },
			pl: { publishableKey: 'prj_test_pk_00f6600081c41843baa7435fb9185ed5ee26e4b6' }
		}
	},
	catOvrGrpId: {
		calia: '3074457345618270104',
		dsg: '3074457345618270104',
		gg: '10501',
		// TODO cart vrst
		vrst: '',
		// pl: ''
		g3: ''
	},
	customizer: 'https://dsg-responsive-v2.mycustomizer.com',
	dataFiles: {
		csv: {
			proxy: {
				path: `assets/csv/`,
				timeout: '15000'
			}
		},
		json: {
			proxy: {
				path: `assets/json/`,
				timeout: '15000'
			}
		}
	},
	defaultActiveCloudProvider: 'AZ',
	esbEnvironmentHeader: 'np6qaprd',
	inventory: {
		locationId: 0
	},
	chk: {
		step1: '/SinglePageCheckout',
		step2: '/SingleShipmentOrderSummaryView?addToWallet=false',
		step3: '/OrderShippingBillingConfirmationView'
	},
	logging: {
		client: {
			level: LoggerLevel.DEBUG
		},
		xhr: {
			level: LoggerLevel.INFO // DO NOT TOUCH
		}
	},
	myAccount: {
		authServiceBaseUrl: 'https://myaccount-authservice.apps.an01.pcf.dcsg.com'
	},
	production: false,
	searchbyTermTypeParam: '1000',
	thirdParty: {
		auth0: {
			...devEnvironmentDefaults.thirdParty.auth0
		},
		honeycomb: {
			apiKey: '',
			serviceName: ''
		},
		images: {
			...devEnvironmentDefaults.images,
			flags: {
				useProxy: false,
				useNetstorage: false
			}
		},
		scene7: {
			baseConfig: {
				baseUrl: 'https://dks.scene7.com/',
				cdn: 'GolfGalaxy/',
				css: 'skins/Scene7SharedAssets/htmlviewerskins/css/html5_mixedmediaviewer_light.css',
				imageDirectory: 'is/image/',
				queryString: '?req=set,json,UTF-8',
				sdkUrl: 's7sdk/3.3/js/s7sdk',
				secureBaseUrl: 'https://dks.scene7.com/',
				videoDirectory: 'is/content/',
				viewerUrl: 's7viewers/html5/js/MixedMediaViewer.js'
			},
			url: 'https://dks.scene7.com/is/image/dkscdn/',
			suffix: '$DSG_ProductCard$',
			timeout: 10000
		},
		bv: {
			store: {
				calia: {
					script: 'https://apps.bazaarvoice.com/deployments/caliastudio/main_site/staging/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				dsg: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/main_site/staging/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				gg: {
					script: 'https://apps.bazaarvoice.com/deployments/golfgalaxy/main_site/staging/en_US/bv.js',
					userToken: 'golfgalaxy-78f5ef807b53fc6fcc0a3f143f3b2a13'
				},
				// TODO cart vrst
				vrst: {
					script: '',
					userToken: ''
				},
				// pl: {
				// 	script: '',
				// 	userToken: ''
				// },
				g3: {
					script: '',
					userToken: ''
				},
				caliaQA: {
					script: 'https://apps.bazaarvoice.com/deployments/caliastudio/qna_enabled_categories/staging/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				dsgQA: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/qna_enabled_categories/staging/en_US/bv.js',
					userToken: 'dsg-be3689187c297c52e22c973ac8bfcaaa'
				},
				ggQA: {
					script: 'https://apps.bazaarvoice.com/deployments/golfgalaxy/qa/staging/en_US/bv.js',
					userToken: 'golfgalaxy-78f5ef807b53fc6fcc0a3f143f3b2a13'
				},
				// TODO cart vrst
				vrstQA: {
					script: '',
					userToken: ''
				},
				// plQA: {
				// 	script: '',
				// 	userToken: ''
				// }
				g3QA: {
					script: '',
					userToken: ''
				}
			},
			api: {
				fullUrl:
					'https://api.bazaarvoice.com/data/products.json?ApiVersion=5.4&Passkey=pviax3zxu03mx4vto1clhr0mo&stats=Reviews&filter=id:eq:',
				baseUrl: 'https://api.bazaarvoice.com/data/',
				contentType: 'products.json',
				version: '?ApiVersion=5.4',
				filters: '&stats=Reviews&filter=id:eq:',
				questionUrl:
					'https://api.bazaarvoice.com/data/products.json?ApiVersion=5.4&Passkey=pviax3zxu03mx4vto1clhr0mo&stats=Questions&filter=id:eq:',
				reviewSummaryUrl: 'https://stg.api.bazaarvoice.com/data/reviews.json',
				revewSummaryApiVersion: '5.4',
				calia: {
					apiPassKey: 'ca0xQmHX4WgFjkpXBiYS8IElwqm2IYIG1RIYQ2LLTnLKA',
					reviewSummaryPassKey: ''
				},
				dsg: {
					apiPassKey: 'ca0xQmHX4WgFjkpXBiYS8IElwqm2IYIG1RIYQ2LLTnLKA',
					reviewSummaryPassKey: 'cartfeWxbkojMChdDJzVpHWbefvA5UY41fRhWqOrDF4hM'
				},
				gg: {
					apiPassKey: 'pviax3zxu03mx4vto1clhr0mo',
					reviewSummaryPassKey: ''
				},
				vrst: {
					// TODO cart vrst
					apiPassKey: '',
					reviewSummaryPassKey: ''
				},
				// pl: {
				// 	apiPassKey: '',
				// 	reviewSummaryPassKey: ''
				// }
				g3: {
					apiPassKey: '',
					reviewSummaryPassKey: ''
				}
			}
		},
		soasta: {
			enabled: false,
			store: {
				calia: 'https://c.go-mpulse.net/boomerang/Y7NJM-H6YK3-37AQ8-UY6YB-3K3S9',
				dsg: 'https://c.go-mpulse.net/boomerang/Y7NJM-H6YK3-37AQ8-UY6YB-3K3S9',
				gg: 'https://c.go-mpulse.net/boomerang/C5JH9-QVK3R-W7E4D-F63VJ-8WKUM',
				// TODO cart vrst
				vrst: '',
				// pl: ''
				g3: ''
			}
		},
		searchDex: {
			gatewayUrlProxy: {
				path: `/cart/sdxincludes/api/`,
				timeout: '15000'
			},
			store: {
				calia: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				dsg: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				gg: {
					baseUrl: 'https://www.golfgalaxy.com/products/includes/'
				},
				vrst: {
					baseUrl: 'https://www.vrst.com/products/includes/'
				},
				pl: {
					baseUrl: 'https://www.publiclands.com/products/includes/'
				},
				g3: {
					baseUrl: 'https://www.goinggoinggone.com/products/includes/'
				}
			}
		},
		tealium: {
			enabled: true,
			store: {
				calia: {
					baseUrl: 'https://tag.caliastudio.com/qa/utag.js'
				},
				dsg: {
					baseUrl: 'https://tag.dickssportinggoods.com/qa/utag.js'
				},
				gg: {
					baseUrl: 'https://tag.golfgalaxy.com/qa/utag.js'
				},
				vrst: {
					baseUrl: 'https://tag.vrst.com/qa/utag.js'
				},
				pl: {
					baseUrl: 'https://tag.publiclands.com/qa/utag.js'
				},
				g3: {
					baseUrl: 'https://tag.goinggoinggone.com/qa/utag.js'
				}
			}
		},
		paypal: {
			store: {
				dsg: {
					baseUrl: 'https://www.paypal.com/sdk/js',
					clientIdParam:
						'?client-id=AYFlO13muLakjKU0FOxYvgCHfUovUT04dv6Ogx14EFAyQATn3gzcVPWNVaD-OkLgaYM4MclE9DYBfucl',
					additionalParams: '&components=messages'
				},
				calia: {},
				gg: {},
				vrst: {},
				// pl: {}
				g3: {}
			}
		},
		affirm: {
			store: {
				dsg: {
					script: 'assets/scripts/affirm.dev.js'
				},
				calia: {},
				gg: {},
				vrst: {},
				// pl: {}
				g3: {}
			}
		},
		payments: {
			script: 'https://payments.dickssportinggoods.com/library/cfj/dev/index-v1.js',
			scriptConfig:
				'https://payments.dickssportinggoods.com/library/cfj/dev/assets-manifest.json',
			fallbackScript: 'assets/scripts/credit-card-form-js/index.js',
			fallbackScriptConfig: 'credit-card-form-js/assets-manifest.json',
			independencePay: {
				cart: {
					primary: {
						config: 'https://payments.dickssportinggoods.com/library/dpbjs/dev/assets-manifest.json',
						script: 'https://payments.dickssportinggoods.com/library/dpbjs/dev/index-v1.js'
					},
					fallback: {
						config: 'dsg-payment-buttons-js/assets-manifest.json',
						script: 'assets/scripts/dsg-payment-buttons-js/index.js'
					}
				},
				payments: {
					primary: {
						config: 'https://payments.dickssportinggoods.com/library/dppjs/dev/assets-manifest.json',
						script: 'https://payments.dickssportinggoods.com/library/dppjs/dev/index-v1.js'
					},
					fallback: {
						config: 'dsg-payment-page-js/assets-manifest.json',
						script: 'assets/scripts/dsg-payment-page-js/index.js'
					}
				}
			}
		},
		afterPay: {
			script: 'https://payments.dickssportinggoods.com/library/bnpl/dev/index-v1.js',
			scriptConfig:
				'https://payments.dickssportinggoods.com/library/bnpl/dev/assets-manifest.json'
		},
		radar: {
			script: 'https://js.radar.com/v4.1.7/radar.min.js',
			stylesheet: 'https://js.radar.com/v4.1.7/radar.css'
		},
		googlePlaces: {
			script: '/maps/api/js'
		}
	},
	feature: {
		...devEnvironmentDefaults.feature,
		dsg: {
			merchantId: 'dks_dsg',
			applePayExternalized: true,
			ceops: true,
			addOns: true,
			feedbackSurvey: true
		},
		gg: {
			merchantId: 'dks_gg',
			applePayExternalized: true,
			ceops: true,
			addOns: false,
			feedbackSurvey: true
		},
		calia: {
			merchantId: 'dks_dsg',
			applePayExternalized: true,
			ceops: true,
			addOns: false,
			feedbackSurvey: true
		},
		vrst: {
			merchantId: 'dks_dsg',
			applePayExternalized: true,
			ceops: true,
			addOns: false,
			feedbackSurvey: true
		},
		pl: {
			merchantId: 'dks_dsg',
			applePayExternalized: true,
			ceops: true,
			// TODO: remove this if we dont plan on turning on again
			addOns: false,
			// product recommendations in cart
			feedbackSurvey: true
		},
		g3: {
			merchantId: 'dks_dsg',
			applePayExternalized: true,
			ceops: true,
			addOns: true,
			feedbackSurvey: true
		}
	},
	killSwitch: {
		addToReachEnabled: {
			calia: false,
			dsg: true,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		sddUpdatedCutoffEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Shows suggested addresses while typing in checkout shipping & billing address form
		addressTypeaheadEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: false
		},
		//Displays affirm pay later button for cart page and payments page
		affirmPayLater: {
			calia: false,
			dsg: true,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Displays afterpay button on cart page and payments page
		afterPay: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: false,
			pl: false,
			g3: false
		},
		altSignInPlacementEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		//Enables the EDD Verbiage AB Test: Color & Font Weight Portion
		boldEDDcartEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		showRelativeArrivalEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		bopisEnabled: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: false,
			pl: true,
			g3: true
		},
		boplEnabled: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: false,
			pl: true,
			g3: true
		},
		eddEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		// changes the cart spinner loading strategy to cover individual cards
		cartUpdatedLoadingStrategy: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		// Shows a modal confirming cart item removal. Exception: cartQtyStepper always shows modal when qty is 0.
		cartItemRemovalModalEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		certonaRecEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		certonaRecWithShowQVButtonsEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		//Gives unregistered users the ability to create an account on the order confirmation page
		createAccountOnOrderConfirm: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		//Allows users to do BOPIS across different chains. (Example: Able to buy product on golfgalaxy.com and pick up at a Dick's Sporting Goods store)
		crossChainBopis: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: false,
			pl: true,
			g3: false
		},
		deliveryOptionEDDEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		checkoutDonationsEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: true
		},
		easyApplyRewardsEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		//Enables cart word in error message above billing card to be clickable
		enableErrorMessageCartLink: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		displayCartAttributesEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		honeycombEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		showCreateAccount: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		showRewardsFormForBrand: {
			dsg: false,
			gg: false,
			calia: true,
			vrst: true,
			pl: false,
			g3: true
		},
		eddAlertsEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		//Shows registered user reward messaging on the empty cart page
		emptyCartExperienceRewardsVisibility: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Prompts user to sign in on empty cart page
		emptyCartExperienceSignInPrompt: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		enableTooltipSurvey: {
			dsg: true,
			gg: true,
			pl: false,
			g3: false
		},
		//enable feed back survay link pages in cart/checkout/confiration pages of spc and mpc
		feedbackSurveyEnabled: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: true,
			pl: true,
			g3: false
		},
		giftingOrderConfirmEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		gtgtEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: true,
			g3: true
		},
		gtgtEvaluatorSunsetEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		guestScoreCardSignInEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		hideAddressLine2Enabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		independencePayEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		//Keeps track of a users checkout session and takes them back to cart if their session exceeds 20 minutes
		manageSession: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		modernCheckoutEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		newEATApiEnabled: {
			calia: false,
			dsg: true,
			gg: false,
			vrst: false,
			pl: true,
			g3: false
		},
		optInMarketing: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		oosProductRecsEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		//Used to help authenticate the users payment
		payerAuthentication: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		//Shows the gift card option on the payment page
		paymentMethodsGiftCard: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: false,
			g3: true
		},
		//Shows the score rewards credit card and score rewards master card option on the payment page
		paymentMethodsPLCC: {
			dsg: true,
			gg: false,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		paymentsCCFormEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		paypalEnabled: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: true,
			pl: true,
			g3: true
		},
		paypalExpressEnabled: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: true,
			pl: false,
			g3: true
		},
		//Displays the paypal pay later button on the cart and payment page
		paypalPayLater: {
			calia: false,
			dsg: false,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Displays the new paypal order summary page
		paypalDisplayNewOrderSummaryPage: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		promiseDayDropdownPlacementEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		promiseDayEDDPlacementEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		promiseDayEDDSameFulfillmentGroupEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		promosEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		proxyPickupEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		pypdCartCheckoutEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		reverseBillingAndShipping: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		saveForLaterEnabled: {
			dsg: false,
			gg: true,
			calia: false
		},
		saveForLaterV2Enabled: {
			dsg: true,
			gg: true,
			pl: true
		},
		//Adds ngsw-worker.js service worker
		serviceWorker: {
			calia: false,
			dsg: false,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Displays a widget under the order total of the potential score card points a user can earn by completing their purchase
		scorecardPointsEarned: {
			dsg: false,
			calia: false,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		// Displays a widget on the order confirmation page of the score card points a user has earned by completing their purchase
		// https://www.figma.com/design/69lYsxXmpTTmrCJrR4uGwr/Cart%2FCheckout%3A-New-Checkout?node-id=10339-4660
		scorecardPointsEarnedOrderConfirm: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		scorecardPointsGuest: {
			dsg: false,
			calia: false,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		// Displays a scorecard icon on the points displays, has no effect if scorecardPointsEarned is false
		scorecardPointsIcon: {
			dsg: false,
			calia: false,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		// Displays same day delivery feature throughout cart and checkout
		sddEnabled: {
			dsg: true,
			gg: true,
			pl: false,
			g3: false
		},
		showCCBanner: {
			calia: false,
			dsg: true,
			gg: false,
			vrst: false,
			pl: false,
			g3: false
		},
		//Product recommendations provided by the data science team
		showDSRecommendations: {
			dsg: true,
			calia: true,
			gg: true,
			vrst: true,
			pl: true,
			g3: true
		},
		//Displays the payment summary on the order confimation page
		showPaymentSummary: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: true,
			pl: true,
			g3: true
		},
		signInEnabled: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: false,
			pl: true,
			g3: false
		},
		//Force the user in multipage checkout to sign it to redeem their rewards.
		signInToReedem: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: false,
			pl: true,
			g3: false
		},
		skuPromoCall: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		smsOptInEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: false
		},
		smsNotificationEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: false
		},
		socialCommerceFlow: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		tipCardContinueButton: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		useNewPricingService: {
			calia: true,
			dsg: true,
			gg: true,
			vrst: true,
			pl: true,
			g3: true
		},
		useAvsV2: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		eddPelotonVerbiageEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		solePanelEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		solePanelPaymentsButton: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		showLTLMessageEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		enableRepositionRecommendations: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		// Moves Checkout button to top of screen
		// Step 1
		checkoutTopOfCartEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		estimatedTotalTopOfCartEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		cartEditEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		checkoutExpressPayButtonTopOfCartEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		summaryCartSticky: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		summaryCartStickyMobileEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		summaryCartStickyMobileDetailsEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		productRecommendationsQuickViewEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		marketingSmsOptInEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		tabbedCarouselRecsEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		truncatedTabbedRecsAndSFL: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		isATRRecsEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		isATRRecsButtonEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		isGiftingV2Enabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		//Toggles whether or not the site is using PromoteIQ or Criteo for their Sponsored Product Ads
		isUsingCriteoSPAAdServer: {
			dsg: true,
			gg: true
		},
		displayOptionsOnLoadEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		visionUpliftEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		warrantiesEnabled: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		},
		isQuantityStepperV2Enabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		}
	},
	tests: {
		dsg: {
			laneCookie: 'swimlane_as_exp_dsg',
			experiences: {}
		},
		gg: {
			laneCookie: 'swimlane_as_exp_gg',
			experiences: {}
		},
		calia: {
			laneCookie: 'swimlane_as_exp_calia',
			experiences: {}
		},
		vrst: {
			laneCookie: 'swimlane_as_exp_vrst',
			experiences: {}
		},
		pl: {
			laneCookie: 'swimlane_as_exp_pl',
			experiences: {}
		},
		g3: {
			laneCookie: 'swimlane_as_exp_g3',
			experiences: {}
		}
	},
	baseUrls: {
		addressService: `${redirectingServiceBase}/addressservice`,
		athleteService: `${redirectingServiceBase}/athleteservice`,
		authService: `${redirectingServiceBase}/authservice`,
		automatedToolingService: `${redirectingServiceBase}/automatedtoolingservice`,
		logonService: `${redirectingServiceBase}/logonservice`,
		orderService: `${redirectingServiceBase}/orderservice`,
		pointService: `${redirectingServiceBase}/pointservice`,
		segmentationService: `${redirectingServiceBase}/segmentationservice`,
		textSubscriptionService: `https://externalcomm-textsubscriptionservice.dcsg.com`,
		consumerApi: `${redirectingServiceBase}/consumerapi`,
		identityService: '/athleterecord/services/redirectingservice/identityservice',
		athleteManagementService: '/myaccount/services/redirectingservice/athletemanagementservice',
		emailValidationService: `${redirectingServiceBase}/emailvalidationservice`,
		loyaltyPointsCalculationService: `${redirectingServiceBase}/pointcalculationservice`
	},
	identityServiceKey: {
		partnerKey: 'cart_ui',
		secretKey: 'BHOuAV90ho1uUSULXWEl'
	},
	apiAuthKeys: {
		partnerKey: 'cart_ui',
		secretKey: 'BHOuAV90ho1uUSULXWEl'
	},
	loyalty: {},
	pricing: {
		path: '/discount/details/',
		esbEnvironmentHeader: 'prdlive'
	},
	solePanel: {
		...devEnvironmentDefaults.solePanel,
		dsg: 'http://localhost:4200'
	},
	isLocal: true
};
